import { gql } from '@apollo/client';
import { VARIANTS_PACK_FRAGMENT } from './items-context-queries';

export const INITIAL_SMART_ORDER_QUERY = gql`
  query Initial_SmartOrder($smartOrderUUID: uuid!) {
    smart_order_by_pk(uuid: $smartOrderUUID) {
      order_uuid
      restaurant_uuid
      uuid
    }
  }
`;

export const SMART_ORDER_RESULTS_QUERY = gql`
  query SmartOrder_ResultsSmartOrder(
    $locale: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $smartOrderUUID: uuid!
    $businessOrganizationUUID: uuid!
  ) {
    smart_order(
      limit: 1
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        uuid: { _eq: $smartOrderUUID }
        supplier: {
          business_organization_uuid: { _eq: $businessOrganizationUUID }
        }
      }
    ) {
      smart_order_results {
        quantity
        search_term
        variant_pack {
          ...ItemsContext_VariantsPackFields
        }
        uuid
      }
      search_inputs
      uuid
    }
  }

  ${VARIANTS_PACK_FRAGMENT}
`;

export const PLACED_SMART_ORDER_QUERY = gql`
  query SmartOrder_PlacedSmartOrder($orderUUID: uuid!) {
    orders_aggregate(where: { parent_orders: { uuid: { _eq: $orderUUID } } }) {
      aggregate {
        count
      }
    }
  }
`;
